// extracted by mini-css-extract-plugin
export var recentlyViewedSection = "recently-viewed-section_MUNuCGdec3alrtq2661S";
export var recentlyViewedSectionContainer = "recently-viewed-section__container_t_1QTht6Q4dLIdKPhR1_";
export var recentlyViewedSectionRecord = "recently-viewed-section__record_u_J_izRH5SvrIUWqsFgD";
export var recentlyViewedSectionRecordsList = "recently-viewed-section__records-list_rX25JEBPuihYVkAG1YaO";